// Utilitaire pour gérer les URLs de l'API de manière centralisée
export const getApiBaseUrl = () => {
  // Utiliser l'API locale en développement, production sinon
  // Docker expose le backend sur 3002, développement local sur 3001
  return import.meta.env.DEV ? 'http://localhost:3002' : 'https://api.flightcasefwi.com'
}

export const getApiUrl = () => {
  return `${getApiBaseUrl()}/api`
}

export const getImageUrl = (imagePath) => {
  if (!imagePath) return ''
  // Normaliser quelques cas tordus
  if (imagePath.startsWith('/.flightcasefwi.com')) {
    // Supprimer le "/." puis préfixer par la bonne base
    const cleaned = imagePath.replace('/.flightcasefwi.com', '')
    return `${getApiBaseUrl()}${cleaned}`
  }
  // Cas absolu mal formé avec protocole
  if (imagePath.includes('://.flightcasefwi.com')) {
    return imagePath
      .replace('https://.flightcasefwi.com', getApiBaseUrl())
      .replace('http://.flightcasefwi.com', getApiBaseUrl())
      .replace('://.flightcasefwi.com', `${getApiBaseUrl()}`)
  }

  // Eviter le double slash quand imagePath commence par '/'
  if (imagePath.startsWith('//')) {
    return `https:${imagePath}`
  }

  // Si l'image est déjà une URL complète, la retourner telle quelle
  if (imagePath.startsWith('http')) {
    return imagePath
  }
  
  // Construire l'URL complète
  return `${getApiBaseUrl()}${imagePath}`
}
